/** @jsx jsx */

import { Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

type Props = {
  theme: 'light' | 'dark';
};

const ByCliToolMessage = ({ theme }: Props) => (
  <Text color={theme === 'dark' ? 'inherit' : undefined}>
    This version was created by the CLI and can only be modified there.{' '}
    <Link
      inverted={theme === 'dark'}
      href={`${BASE_DOC_URL_VB}/quickstart/zapier-platform`}
      target="_blank"
    >
      Learn more.
    </Link>
  </Text>
);

export default ByCliToolMessage;
